// Generated by scripts/write-version.js — do not edit.
export const release = "2026.3.1";
export const buildStamp = "20261008171023";
const buildStampDefault = "20261008171023";
export default buildStampDefault;
